export default "__VITE_ASSET__BPqRMr0J__"